const styles = () => ({
	description: {
		margin: '24px 5% 0',
		maxWidth: '87.5%',

		textAlign: 'justify',
		fontSize: '18px',
		fontStyle: 'normal',
		fontWeight: 300,
		lineHeight: '24px',

		color: '#444444'
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/pages/main/files/styles.js